import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { Provider } from 'react-redux';
import { Link, useRouteMatch, useHistory, withRouter } from "react-router-dom";
import configureStore from './store/store';
import { AuthProvider } from "./store/provider/AuthProvider";
// import { createBrowserHistory } from "history";

import { Layout } from './components/Layout';
import { Login } from './components/Auth/Login';
import { LineaNegocio } from './components/Auth/LineaNegocio';
import { RazonSocial } from './components/Auth/RazonSocial';
import { VerificarCorreo } from './components/Auth/VerificarCorreo';
import { IngresarContrasenia } from './components/Auth/IngresarContrasenia';
import { RecuperarContrasenia } from './components/RecoverPassword/Index';
import { RCVerificarCorreo } from './components/RecoverPassword/VerificarCorreo';
import { NuevaContrasenia } from './components/RecoverPassword/NuevaContrasenia';
import { SolicitarAcceso } from './components/Auth/SolicitarAcceso';
import { Dashboard } from './components/General/Dashboard';
import { Notificaciones } from './components/General/Notificaciones';
import { GenerarPedidoMasivo } from './components/Pedidos/GenerarPedidoMasivo';
import { PedidoMasivo } from './components/Pedidos/PedidoMasivo';
import { GenerarPedido } from './components/Pedidos/GenerarPedido';
import { GenerarPedidoDesktop } from './components/Pedidos/GenerarPedidoDesktop';
import { BuscadorCodigo } from './components/Pedidos/BuscadorCodigo';
import { BuscadorVehiculo } from './components/Pedidos/BuscadorVehiculo';
import { Repuestos } from './components/Pedidos/Repuestos';
import { Carrito } from './components/Carrito/Listado';
import { CarritoOfertas } from './components/Carrito/Ofertas';
import { CarritoEnvio } from './components/Carrito/Envio';
import { Transportistas } from './components/Carrito/Transportistas';
import { CarritoMedioPago } from './components/Carrito/MedioPago';
import { ResumenPedido } from './components/Carrito/ResumenPedido';
import { PedidoFinalizado } from './components/Carrito/PedidoFinalizado';
import { Perfil } from './components/Perfil/Index';
import { CambiarContrasenia } from './components/Perfil/CambiarContrasenia';
import { Locales } from './components/Perfil/Locales';
import { Dispositivos } from './components/Perfil/Dispositivos';
import { TransportistasPerfil } from './components/Perfil/Transportistas';
import { PedidoSugerido } from './components/General/PedidoSugerido';
import { PrePedidos } from './components/General/PrePedidos';
import { ListaDeseos } from './components/General/ListaDeseos';
import { ProductosVendidos } from './components/Catalogo/ProductosVendidos';
import { Ofertas } from './components/Catalogo/Ofertas';
import { HistorialPedidos } from './components/HistorialPedidos/Listado';
import { DetallePedido } from './components/HistorialPedidos/DetallePedido';
import { Tracking } from './components/HistorialPedidos/Tracking';
import { EstadoCuenta } from './components/EstadoCuenta/Listado';
import { EstadoCuentaDetalle } from './components/EstadoCuenta/Detalle';
import { Bonificaciones } from './components/Bonificaciones/Index';
import { Bonificacion } from './components/Bonificaciones/Bonificacion';
import { BonificacionGrafico } from './components/Bonificaciones/Grafico';
import { PreguntasFrecuentes } from './components/Ayuda/PreguntasFrecuentes';
import { Incidente } from './components/Ayuda/Incidente';
import { Requerimientos } from './components/Ayuda/Requerimientos';
import { EliminarCuenta } from './components/General/EliminarCuenta';

//NAVEGACIÓN VEHÍCULO
import { VehiculoDashboard } from './components/Vehiculos/General/Dashboard';
import { RepresentanteVenta } from './components/Vehiculos/General/RepresentanteVenta';
import { Sugerencias } from './components/Ayuda/Sugerencias';


import './custom.scss';
import './assets/sass/style.scss';



const store = configureStore();

function CarritoSwitch() {
  let { path, url } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={Carrito} />
      <Route path={`${path}/ofertas`}  component={CarritoOfertas} />
      <Route path={`${path}/envio`}  component={CarritoEnvio} />
      <Route path={`${path}/transportistas`}  component={Transportistas} />
      <Route path={`${path}/medio-pago`}  component={CarritoMedioPago} />
      <Route path={`${path}/resumen-pedido`}  component={ResumenPedido} />
      <Route path={`${path}/pedido-finalizado`}  component={PedidoFinalizado} />
    </Switch>
  );
}

export default class App extends Component {
  static displayName = App.name;
  
  render () {
    const {history} = this.props;
    return (
      <Provider store={store}>
        <AuthProvider>
          <Layout history={history}>
            <Route exact path='/' component={Login} />
            <Route exact path='/linea-negocio' component={LineaNegocio} />
            <Route path='/razon-social' component={RazonSocial} />
            <Route path='/verificar-correo' component={VerificarCorreo} />
            <Route path='/ingresar-contrasenia' component={IngresarContrasenia} />
            <Route path='/recuperar-contrasenia' component={RecuperarContrasenia} />
            <Route path='/verificar-correo-contrasenia' component={RCVerificarCorreo} />
            <Route path='/nueva-contrasenia' component={NuevaContrasenia} />
            <Route path='/solicitar-acceso' component={SolicitarAcceso} />
            <Route path='/dashboard' component={Dashboard} />
            <Route path='/notificaciones' component={Notificaciones} />
            <Route path='/generar-pedido-masivo' component={GenerarPedidoMasivo} />
            <Route path='/pedido-masivo' component={PedidoMasivo} />
            <Route path='/generar-pedido' component={GenerarPedido} />
            <Route path='/generar-pedido-desktop' component={GenerarPedidoDesktop} />
            <Route path='/buscador-codigo' component={BuscadorCodigo} />
            <Route path='/buscador-vehiculo' component={BuscadorVehiculo} />
            <Route path='/repuestos' component={Repuestos} />
            <Route path='/carrito' component={CarritoSwitch} />
            <Route path='/perfil' component={Perfil} />
            <Route path='/transportistas' component={TransportistasPerfil} />
            <Route path='/cambiar-contrasenia' component={CambiarContrasenia} />
            <Route path='/locales' component={Locales} />
            <Route path='/dispositivos' component={Dispositivos} />
            <Route path='/pedido-sugerido' component={PedidoSugerido} />
            <Route path='/pre-pedidos' component={PrePedidos} />
            <Route path='/lista-deseos' component={ListaDeseos} />
            <Route path='/productos-comprados' component={ProductosVendidos} />
            <Route path='/ofertas' component={Ofertas} />
            <Route path='/historial-pedidos' component={HistorialPedidos} />
            <Route path='/detalle-pedido' component={DetallePedido} />
            <Route path='/tracking' component={Tracking} />
            <Route path='/estado-cuenta' component={EstadoCuenta} />
            <Route path='/estado-cuenta-detalle' component={EstadoCuentaDetalle} />
            <Route path='/bonificaciones' component={Bonificaciones} />
            <Route path='/bonificacion' component={Bonificacion} />
            <Route path='/bonificacion-grafico' component={BonificacionGrafico} />
            <Route path='/preguntas-frecuentes' component={PreguntasFrecuentes} />
            <Route path='/incidente' component={Incidente} />
            <Route path='/requerimientos' component={Requerimientos} />
            <Route path='/sugerencias' component={Sugerencias} />
            <Route path='/eliminar-cuenta' component={EliminarCuenta} />
            {/* -------------- */}
            
            <Route path='/representante-venta' component={RepresentanteVenta} />
            <Route path='/vehiculo-dashboard' component={VehiculoDashboard} />
            
          </Layout>
        </AuthProvider>
      </Provider>
    );
  }
}
